import BaseTextField from "@mui/material/TextField";

const TextField = ({ name, iconStart, iconEnd, inputProps, ...props }) => {
  return (
    <BaseTextField
      variant="outlined"
      id={name ? name : null}
      {...props}
      inputProps={{
        ...inputProps,
        // startAdornment: iconStart ? (
        //   <InputAdornment position="start">{iconStart}</InputAdornment>
        // ) : null,
        // endAdornment: iconEnd ? (
        //   <InputAdornment position="end">{iconEnd}</InputAdornment>
        // ) : null
      }}
      sx={{
        "& .MuiInputBase-root": {
          bgcolor: "#FFF",
        },
        "& .MuiOutlinedInput-root": {
          alignItems: props.multiline ? "flex-start" : "center",
        },
        "& .MuiInputAdornment-root": {
          marginTop: props.multiline ? "0.8rem" : "0",
        },
      }}
    />
  );
};

export default TextField;
